var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm._column.marks.is('IS_ADMIN'))?_c('vd-online',{key:_vm._column.id,attrs:{"online":_vm._column.onLineList},on:{"openForceDialog":_vm.openForceDialog}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }